import { render, staticRenderFns } from "./GloriousHistory.vue?vue&type=template&id=49e9b6be&"
import script from "./GloriousHistory.vue?vue&type=script&lang=js&"
export * from "./GloriousHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports